import { Edit, MarkChatUnread, Photo } from '@mui/icons-material';
import {
  Checkbox,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { GenCurrency } from '@pinnacleautomotive/clarity-components';

export default function ServiceRow({
  service,
  selectedPrices,
  onSelectPrice,
  onOpenEstimateDialog,
}) {
  const theme = useTheme();
  const isBellowSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const labelId = `checkbox-list-secondary-label-${service.servicePriceId}`;
  const infoUpdated = selectedPrices?.find(
    sp => sp.servicePriceId === service.servicePriceId
  );
  const checked = !!infoUpdated;

  const data = { ...service, ...infoUpdated };

  const openEstimateDialog = event => {
    event.preventDefault();
    event.stopPropagation();
    onOpenEstimateDialog(data);
  };

  return (
    <ListItem key={data.servicePriceId} disablePadding>
      <ListItemButton
        onClick={() => onSelectPrice(data, checked)}
        sx={{ px: isBellowSmall ? 0 : 2 }}
      >
        <ListItemIcon sx={{ minWidth: { xs: 'auto', sm: '56px' } }}>
          <Checkbox
            checked={checked}
            inputProps={{ 'aria-labelledby': labelId }}
            sx={{ pl: { xs: 0, sm: 1 } }}
          />
        </ListItemIcon>
        <ListItemText
          id={labelId}
          primary={service.service.name}
          primaryTypographyProps={{ variant: 'body1' }}
          sx={{ width: 'calc(80% - 56px)' }}
          secondary={
            checked && (
              <>
                x{data.quantity} • <GenCurrency value={data.price} />
              </>
            )
          }
        />
      </ListItemButton>
      {checked && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          divider={<Divider orientation="vertical" flexItem />}
          width={{ xs: '180px', sm: '240px' }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            flexGrow={1}
            px={{ xs: 0, sm: 2 }}
          >
            {!!data.files?.length && (
              <IconButton
                size="small"
                color="primary"
                disabled={false}
                sx={{ color: theme.palette.info.light }}
              >
                <Photo />
              </IconButton>
            )}
            {data.comments && (
              <IconButton
                size="small"
                disabled={false}
                sx={{ color: theme.palette.info.light }}
              >
                <MarkChatUnread />
              </IconButton>
            )}
          </Stack>
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            gap={1}
            sx={{ width: '140px' }}
          >
            <GenCurrency value={data.amount} />
            <IconButton
              size="small"
              color="default"
              onClick={openEstimateDialog}
            >
              <Edit />
            </IconButton>
          </Stack>
        </Stack>
      )}
    </ListItem>
  );
}
